<template>
  <div class="r-auth-login row">
    <div class="col-sm-6 recycling-image d-none d-md-block"></div>
    <div class="col-md-6">
      <div style="width: 80%; margin: 0 auto;">
        <br>
        <h1 class="mt-5">Welcome to Recovinyl</h1>
        <h4 class="mt-3" style="opacity: 0.7; font-size: 20px;">We make it easy for you to ...</h4>
        <br>

        <h1 class="mt-5 mb-5">Login</h1>
        <form
          style="padding-bottom: 100px;"
          class="mt-2"
          method="post"
          name="test"
          @submit.prevent="handleSubmit"
        >
          <base-text
            name="email"
            label="Email address"
            v-validate="'required|email'"
            v-model="email"
            :err="errors.collect('email')"
          />

          <base-text
            name="password"
            type="password"
            label="Password"
            v-validate="'required|min:6'"
            v-model="password"
            :err="errors.collect('password')"
          />

          <div class="row mt-5">
            <div class="col-6 text-left">
              <base-button
                radius="bl"
                component-class="blue filled"
                type="button"
                @click.native="$router.push({ name: 'auth-register' })"
              >
                <i class="fas fa-unlock mr-3"></i> Register
              </base-button>
            </div>
            <div class="col-6 text-right">
              <base-button radius="br" component-class="green filled" type="submit">
                Log in
                <i class="fas fa-arrow-right ml-3"></i>
              </base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/inputs/button/BaseButton';
import BaseText from '@/components/inputs/text/BaseText';

export default {
  data() {
    return {
      email: '',
      password: '',
    };
  },

  methods: {
    async handleSubmit() {
      try {
        const isValidForm = await this.$validator.validateAll();
        if (isValidForm) {
          const isLogged = await this.$store.dispatch('auth/login', {
            email: this.email,
            password: this.password,
          });
          if (isLogged) {
            this.$router.push({ name: 'user.dashboard' });
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  },

  mounted() {
    this.$store.commit('app/setContainerClass', 'pt-0 pb-0');
  },

  beforeDestroy() {
    this.$store.commit('app/setContainerClass', '');
  },

  components: {
    'base-button': BaseButton,
    'base-text': BaseText
  }
};
</script>
